import React, { useState, useEffect, useRef } from 'react'
import '../CoursePage/CoursePage.css'
import Curriculum from "../Curriculum/Curriculum.jsx";
import fullstack from "../../assets/software.png";
import jrrightgirl from "../../assets/jrrightgirl.jpg";
import fsfoundational from "../../assets/fshfoundational.jpg";
import fsh1foundational from "../../assets/fsh1foundational.jpg"
import fsintermediate from "../../assets/fshintermediate.jpeg";
import fsh1intermediate from "../../assets/fsh1intermediate.jpg"
import fsadvanced from "../../assets/fshadvanced.jpg";
import fsh1advanced from "../../assets/fsh1advanced.jpeg"
import coursepath1 from '../../assets/coursepath1.jpg';
import coursepath2 from '../../assets/coursepath2.jpg';
import coursepath3 from '../../assets/coursepath3.jpeg';
import coursepath4 from '../../assets/coursepath4.jpg';
import coursepathl1 from '../../assets/coursepathl1.png';
import coursepathl2 from '../../assets/coursepathl2.png';
import coursepathl3 from '../../assets/coursepathl3.png';

import cloudzest from '../../assets/cloudzest.jpg'
import virtusa from '../../assets/Virtusa.png'
import cognizant from '../../assets/cognizant.png'
import accenture from '../../assets/Accenture.png'
import techmahindra from '../../assets/TMlogo.png'
import trigent from '../../assets/trigent.png'
import info from '../../assets/info.jpg'
import lti from '../../assets/lti.png'
import prodapt from '../../assets/prodapt.png'
import straive from '../../assets/straive.jpg'
import concentrix from '../../assets/Concentrix.png'
import nttdata from '../../assets/ntt data.png'
import walkingtree from '../../assets/walkingtree.png'
import globallogic from '../../assets/globallogic.png'
import deloitte from '../../assets/deloitte.png'
import blueyonder from '../../assets/blueyonder.png'
import covalense from '../../assets/covalense.jpg'
import lancesoft from '../../assets/Lancesoft.png'
import statusneo from '../../assets/statusneo.jpg'


import Amazon from "../../assets/logos/Amazon Logo.webp";
import capgemini from "../../assets/logos/Capgemini Logo.webp";
import HSBC from "../../assets/logos/HSBC Logo.webp"
import lowes from "../../assets/logos/Lowes logo.webp";
import Maersk from "../../assets/logos/Maersk Logo.webp";
import Make from "../../assets/logos/MakeMyTrip Logo.webp";
import Optum from "../../assets/logos/Optum Logo.webp";
import tata from "../../assets/logos/Tata Digital Logo.webp";
import thoughtworks from "../../assets/logos/Thoughtworks Logo.webp";
import visa from "../../assets/logos/VISA Logo.webp";
import mentorcompany from '../../assets/mentorcompany.png';
import trusted from "../../assets/WebsitePlacement.png";

import mentorimage from '../../assets/mentorimage.png';
import mentorimage2 from '../../assets/mentorimage2.png';
import mentorimage3 from '../../assets/mentorimage3.png';
import mentorimage4 from '../../assets/mentorimage4.png';
import mentorimage5 from '../../assets/mentorimage5.png';
import mentorimage6 from '../../assets/mentorimage6.png';
import mentorimage8 from '../../assets/mentorimage8.png';
import mentorimage9 from '../../assets/mentorimage9.png';
import mentorimage10 from '../../assets/mentorimage10.jpeg';
import mentorimage11 from '../../assets/mentorimage11.png';
import mentorimage12 from '../../assets/mentorimage12.png';
import mentorimage13 from '../../assets/mentorimage13.png';
import mentorimage14 from '../../assets/mentorimage14.png';
import mentorimage15 from '../../assets/mentorimage15.JPG';
import mentorimage16 from '../../assets/mentorimage16.png';
import mentorimage17 from '../../assets/mentorimage17.png';
// import mentorimage18 from '../../assets/mentorimage18.jpeg';
import mentorimage19 from '../../assets/mentorimage19.png';
import mentorimage20 from '../../assets/mentorimage20.png';
import mentorimage21 from '../../assets/mentorimage21.png';
import mentorimage22 from '../../assets/mentorimage22.png';
import mentorimage23 from '../../assets/mentorimage23.png';
import mentorimage24 from '../../assets/mentorimage24.png';
import mentorimage25 from '../../assets/mentorimage25.png';
import mentorimage26 from '../../assets/mentorimage26.png';
import mentorimage27 from '../../assets/mentorimage27.png';
import mentorimage28 from '../../assets/mentorimage28.png';
import certificate from '../../assets/certificatecourse.png';
import ibmcertificate from '../../assets/certificateportion2.png';
import microsoftcertificate from '../../assets/certificateportion1.png';
// import certificationcourse from '../../assets/certificatecourse.png';
import { FaSackDollar } from "react-icons/fa6";
import bessential from "../../assets/bootcampessential.png";
import bplus from "../../assets/bootcampplus.png";
import bpro from "../../assets/bootcamppro.png";

import fsreact from "../../assets/fsreact.jpg";
import fsnode from "../../assets/fsnode.jpeg";
import fsexpress from "../../assets/fsexpress.png";
import fsmongodb from "../../assets/fsmongodb.jpeg";
import fsfigma from "../../assets/fsfigma.png";
import fspostman from "../../assets/fspostman.png";

import boexcel from '../../assets/boexcel.jpg';
import bosql from '../../assets/bosql.png';
import bopowerbi from'../../assets/bopowerbi.jpg';
import botableau from '../../assets/botableau.jpg';
import bonumpypanda from '../../assets/bonumpypanda.png';
import bobusinessstatistics from '../../assets/bobusinessstatistics.jpg';
import bopython from '../../assets/bopython.jpg';
import boaws from '../../assets/boaws.png';
import bobigdata from '../../assets/bobigdata.png';
import { FaUsersLine } from "react-icons/fa6";
import { LuSendHorizontal } from "react-icons/lu";
// import certificate from '../../assets/certificatecourse.png'
import upskill from "../../assets/upskill.svg";
import $ from 'jquery';
import { FaArrowRight } from 'react-icons/fa'; 
import gifone from '../../assets/gifone.png';
import giftwo from '../../assets/giftwo.png';
import gifthree from '../../assets/gifthree.png';
import giffour from '../../assets/giffour.png';
import { FaBriefcase } from "react-icons/fa";
import CanvasJSReact from '@canvasjs/react-charts';



import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const FullStack = () => {

      const [activeTab, setActiveTab] = useState('IBM');

      const steps = [
        { img: gifone, title: 'Upskill Now', description: 'Live sessions, expert 1:1 doubt clearing, and quizzes.' },
        { img: giftwo, title: 'Capstone Projects', description: 'Work with industry experts on practical projects.' },
        { img: gifthree, title: 'Boost Profile', description: 'Mock interviews and resume-building sessions.' },
        { img: giffour, title: 'Career Goals', description: 'Get placement assistance with top companies.' }
      ];
    
      useEffect(() => {
        $(window).on('scroll', function () {
          $('.journey-container').each(function () {
            const top = $(this).offset().top;
            const windowTop = $(window).scrollTop();
            const windowHeight = $(window).height();
    
            if (windowTop + windowHeight > top + 100) {
              $(this).addClass('animate');
            } else {
              $(this).removeClass('animate');
            }
          });
        });
    
        return () => $(window).off('scroll');
      }, []);

      const certifications = {
        IBM: {
          title: 'Course Completion Certificate from IBM',
          points: [
            'Complete your training with the internationally recognized certificate.',
            'Validate your Data Science, Data Analytics, Cyber Security and Full Stack Development skills with IBM Course Completion Certificate.',
            'Get acknowledged in IT sector by adding IBM Certificate to your profile.'
          ],
          img: ibmcertificate
        },
        Microsoft: {
          title: 'Course Completion Certificate from Microsoft',
          points: [
            'Complete your training with Microsoft Certification.',
            'Validate your skills with Microsoft Course Completion Certificate.',
            'Showcase your expertise with globally recognized certificates.'
          ],
          img: microsoftcertificate
        },
        'Project Certificate': {
          title: 'Project Completion Certificate',
          points: [
            'Successfully complete your capstone projects.',
            'Work with industry-standard tools and technologies.',
            'Showcase your hands-on project experience.'
          ],
          img: certificate
        }
      };

      const statsData = [
        { number: 120, text: "Live Hours" },
        { number: 40, text: "Tools" },
        { number: 20, text: "Projects" },
        { number: 50, text: "Assessments" },
        { number: 250, text: "Mentorship Hours" },
      ];

  const [counts, setCounts] = useState(statsData.map(() => 0));

  const data = {
    labels: ['0-1 yrs', '1-4 yrs', '5-9 yrs', '10-14 yrs'],
    datasets: [
      {
        label: 'Salary (LPA)',
        data: [5, 8, 14, 24],
        backgroundColor: '#FF4C4C',
        borderRadius: 5,
        borderSkipped: false,
        barThickness: 80,
        categoryPercentage: 1, // Reducing space between bars
        barPercentage: 1, // Adjusting bar width ratio within category
      },
    ],
  };

  const option = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: '#1c0606',
        },
      },
      title: {
        display: true,
        text: 'Salary Growth Over Experience',
        color: '#1c0606',
        font: {
          size: 20,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          color: '#1c0606',
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)',
          drawBorder: false, // Remove the Y-axis border line
          lineWidth: 2,
          display: true,
        },
      },
      x: {
        ticks: {
          color: '#1c0606',
        },
        grid: {
          display: false,
        },
      },
    },
    animation: {
      duration: 1500,
      easing: 'easeOutBounce',
    },
  };

  useEffect(() => {
    const intervals = statsData.map((stat, index) => {
      return setInterval(() => {
        setCounts((prevCounts) => {
          const newCounts = [...prevCounts];
          if (newCounts[index] < stat.number) {
            newCounts[index] += 1; // Increase by 1 per interval
          } else {
            clearInterval(intervals[index]); // Stop when target reached
          }
          return newCounts;
        });
      }, 80); // Adjust speed for smoother animation
    });

    return () => intervals.forEach(clearInterval); // Cleanup on unmount
  }, []);


  const curriculumRef = useRef(null); // Create a reference

  // Function to scroll to the Curriculum component
  const handleScrollToCurriculum = () => {
    if (curriculumRef.current) {
      curriculumRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const Card = ({ image, title, description }) => (
    <div className="Handonexperience-card">
      <img src={image} alt={title} className="Handonexperience-card-image" />
      <h2 className="Handonexperience-card-title">{title}</h2>
      <p className="Handonexperience-card-description">{description}</p>
    </div>
  );

  const companyLogos = [
    cloudzest,
    virtusa,
    cognizant,
    lancesoft,
    accenture,
    techmahindra,
    covalense,
    info,
    capgemini,
    lti,
    deloitte,
    blueyonder,
    concentrix,
    nttdata,
    statusneo
  ];

  const mentors = [
    { name: "Venkata Sai", role: "Full Stack Data Scientist", image: mentorimage, company: cloudzest },
    { name: "Bhargav Lakshman", role: "Machine Learning Engineer", image: mentorimage2, company: capgemini },
    { name: "Burra Jyothi", role: "Data Engineer", image: mentorimage3, company: virtusa },
    { name: "Chinna Ram", role: "Cybersecurity Engineer", image: mentorimage4, company: cognizant },
    { name: "Nagi Reddy", role: "Security Analyst", image: mentorimage5, company: lancesoft },
    { name: "Guguloth Veranna", role: "Security Architect", image: mentorimage6, company: accenture },
    { name: "Jangam Rajasekhar", role: "React.Js Developer", image: mentorimage8, company: techmahindra},
    { name: "Leelachaitanya", role: "Data Analyst", image: mentorimage9, company: trigent },
    { name: "Satyavamsi", role: "Business Intelligence Analyst", image: mentorimage10, company: info },
    { name: "Naresh Kumar", role: "Data Storyteller", image: mentorimage11, company: lti },
    { name: "Gopinadh Reddy", role: "Data Security Analyst", image: mentorimage12, company: prodapt},
    { name: "Mahesh Bathula", role: "Security Data Scientist", image: mentorimage13, company: accenture},
    { name: "Mahesh Nandibattina", role: "React.Js Developer", image: mentorimage14, company: straive },
    { name: "Krishna Reddy", role: "Frontend Developer", image: mentorimage15, company: lti },
    { name: "Pavan Kalyan", role: "Backend Developer", image: mentorimage16, company: lti },
    { name: "Nitta Vinod", role: "Web Application Developer", image: mentorimage17, company: concentrix },
    { name: "Thirupathamma", role: "DevOps Engineer", image: mentorimage19, company: nttdata },
    { name: "Simhachalam", role: "Software Engineer", image: mentorimage20, company: walkingtree },
    { name: "Srevali Pachi pulusu", role: "NLP Engineer", image: mentorimage21, company: globallogic },
    { name: "Vasam Arunkumar", role: "Research Scientist", image: mentorimage22, company: blueyonder },
    { name: "Raja Sekhar", role: "Machine Learning Engineer", image: mentorimage23, company: techmahindra },
    { name: "vijay bhele", role: "AI Engineer", image: mentorimage24, company: accenture },
    { name: "Mekala Anil", role: "Ethical Hacker", image: mentorimage25, company: deloitte },
    { name: "Pooja Joshi", role: "Information Security Specialist", image: mentorimage26, company: concentrix },
    { name: "Naveen kumar", role: "Incident Responder", image: mentorimage27, company: covalense},
    { name: "Akhil", role: "Network Security Engineer", image: mentorimage28, company: statusneo },
  ];

  const carouselRef = useRef(null);

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        if (carouselRef.current.scrollLeft >= carouselRef.current.scrollWidth / 2) {
          // Reset scroll to create infinite loop effect
          carouselRef.current.scrollLeft = 0;
        } else {
          carouselRef.current.scrollLeft += 1; // Adjust for smooth speed
        }
      }
    }, 30); // Adjust speed here

    return () => clearInterval(scrollInterval);
  }, []);

  const Cards = ({ image, title, description }) => (
    <div className="bootcamp-card">
      <img src={image} alt={title} className="bootcamp-card-image" />
      <h2 className="bootcamp-card-title">{title}</h2>
      <p className="bootcamp-card-description">{description}</p>
    </div>
  );

  const [activeTabs, setActiveTabs] = useState(0);

  const tabs = [
    "Entry Criteria",
    "Program Delivery + Expected Outcomes",
    "Payment Details",
    "Interview Opportunity",
  ];

  const faqs = [
    {
      question: "Can I get any special discount for this program?",
      answer:
        "We are offering you this program at competitive rates. Hence, we are not offering any discounts; however, we have a lot of financing options to support you to do this program.",
    },
    {
      question: "Do I need prior experience?",
      answer: "Only selected advanced programs may require a basic screening or test.",
    },
    {
      question: "Are there any age restrictions?",
      answer: "Most courses are open to learners aged 16 and above.",
    },
    {
      question:
        "Do I need to pass an entrance exam?",
      answer: "Only selected advanced programs may require a basic screening or test.",
    },
  ];

  const toggleTab = (index) => {
    setActiveTabs(index);
  };


  const [currentTab, setCurrentTab] = useState("Full Stack Developer");

  // Data for info cards for each tab
  const tabData = {
    "Full Stack Developer": [
      {
        title: "Annual Average Salaries",
        image: "bragraph", // Replace with your actual variable
        companies: [],
        description: "",
      },
      {
        title: "Top Companies",
        companies: [
          "amazonlogo", // Replace with your actual variable names
          "axislogo",
          "accenturelogo",
          "careerlogo",
          "capgeminilogo",
        ],
      },
      {
        title: "Demand",
        image: "demandpie", // Replace with your actual variable
        description: "Surge in job postings between 2020 and 2023",
      },
    ],
    "Team Lead": [
      {
        title: "Leadership Salaries",
        image: "leadershipGraph", // Replace with your actual variable
      },
      {
        title: "Growing Companies",
        companies: [
          "teamLeadLogo1",
          "teamLeadLogo2",
          "teamLeadLogo3",
        ],
      },
      {
        title: "Demand",
        image: "teamDemandGraph", // Replace with your actual variable
        description: "Growth in demand for leadership roles",
      },
    ],
    "Director of Engineering": [
      {
        title: "Director Salaries",
        image: "directorGraph", // Replace with your actual variable
      },
      {
        title: "High-Level Companies",
        companies: [
          "directorLogo1",
          "directorLogo2",
          "directorLogo3",
        ],
      },
      {
        title: "Demand",
        image: "directorDemandGraph", // Replace with your actual variable
        description: "Demand for engineering leadership roles",
      },
    ],
  };

    const [showGraphs, setShowGraphs] = useState(false);
    const [activeTabing, setActiveTabing] = useState("Front-End");
  
    useEffect(() => {
      const handleScroll = () => {
        const graphSection = document.querySelector(".gr-ds-graph");
        const graphPosition = graphSection.getBoundingClientRect().top;
        const screenPosition = window.innerHeight / 1.3;
  
        if (graphPosition < screenPosition) {
          setShowGraphs(true);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  
    const handleTabClick = (tab) => {
      setActiveTabing(tab);
    };
  
    const options = {
      animationEnabled: true,
      exportEnabled: true,
      theme: "light2",
      title: {
        text: "Salaries"
      },
      axisY: {
        includeZero: true
      },
      data: [{
        type: "column",
        indexLabelFontColor: "#00008b",
        indexLabelPlacement: "outside",
        dataPoints: [
          { label: "Min (5L)", y: 5 ,color: "#00008b"},
          { label: "Average (8L)", y: 8 ,color: "#00008b"},
          { label: "Max (24L)", y: 24 ,color: "#00008b"}
        ]
      }]
    };

    const companyImages = [
      visa,
      thoughtworks,
      tata,
      Optum,
      Make,
      Maersk,
      lowes,
      HSBC,
      capgemini,
      Amazon,
    ];

  return (
    <div>

      <div className="hero-wrapper">
        <div className="container-course-page">
          <div className="tagline">Design & Shape the Future of Coding with AI Code Assistant!</div>
          <h1 className="title">Advanced Job-Ready Full Stack Web Development with AI Integration</h1>
          <p className="subtitle">
            Transform your Tech Career with Industry-Aligned, In-Demand Skills and AI-Powered Code Assistance
          </p>
          <div className="button-wrapper">
            <button className="apply-button">Apply Now</button>
            <button className="download-button" onClick={handleScrollToCurriculum}>Download Syllabus</button>
          </div>
          <div className="content-wrapper">

            <img src={fullstack} alt="fullstack" className="image-wrapper" />

            <div className="text-wrapper">
              <div className="feature">
                {/* <LuSendHorizontal className="course-1-icons" /> */}
                <p className="feature-text">
                  <b>Master In-Demand Skills:</b> Gain expertise in advanced technologies in Mongo DB, Express JS, React JS, Node JS, AWS/Azure Cloud, Figma, Generative AI Skills.
                </p>
              </div>
              <div className="feature">
                {/* <LuSendHorizontal className="course-1-icons" /> */}
                <p className="feature-text">
                  <b>Learn from Industry Experts:</b> Receive mentorship from expert professionals & personalized guidance.
                </p>
              </div>
              <div className="feature">
                {/* <LuSendHorizontal className="course-1-icons" /> */}
                <p className="feature-text">
                  <b>Land Your Dream Job:</b> Secure opportunities at top-tier tech companies and innovative startups.
                </p>
              </div>
            </div>


            <img src={jrrightgirl} alt="Person 2" className="image-wrapper" />

          </div>
        </div>

      </div>

      <div className="stats">
        {statsData.map((stat, index) => (
          <div className="stat" key={index}>
            <h2 className="stat-number">{counts[index]}+</h2>
            <p className="stat-text">{stat.text}</p>
          </div>
        ))}
      </div>

      <div ref={curriculumRef}>
        <Curriculum />
      </div>

          <div className="journey-container">
            <h2>Learning Journey at Hruthi Ai</h2>
            <div className="journey-steps">
              {steps.map((step, index) => (
                <div key={index} className="journey-step">
                  <div className="journey-icon">
                    <img src={step.img} alt={step.title} />
                  </div>
                  {index < steps.length - 1 && <FaArrowRight className="arrow-icon" />}
                </div>
              ))}
            </div>
            <div className="journey-details">
              {steps.map((step, index) => (
                <div key={index} className="journey-card">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              ))}
            </div>
          </div>

      <>
        <div className="Handonexperience-container">
          <header className="Handonexperience-header">
            <h3 className="Handonexperience-subheading">
              Build your skills through real-world projects
            </h3>
            <h1 className="Handonexperience-heading">
              Gain Hands-on Experience that Sets You Apart
            </h1>
          </header>

          <section className="Handonexperience-offerings">
            <Card
              image={fsfoundational}
              title="Foundational Project"
              description="An intermediate-level online quiz project challenges learners to implement dynamic question handling, scoring, and user interaction. It strengthens skills in logic building, state management, and UI design."
            />
            <Card
              image={fsintermediate}
              title="Intermediate Project"
              description="An online quiz app project lets users take timed quizzes with instant feedback and scoring. It builds skills in dynamic UI rendering, state management, and user interaction."
            />
            <Card
              image={fsadvanced}
              title="Advanced Project"
              description="An advanced Ola clone project simulates a ride-booking platform with real-time tracking, fare calculation, and driver-user matching. It showcases expertise in geolocation, APIs, and scalable full-stack architecture. "
            />
          </section>
          <section className="Handonexperience-offerings">
            <Card
              image={fsh1foundational}
              title="Foundational Project"
              description="A BookMyShow clone project replicates movie and event ticket booking with seat selection, payment integration, and user authentication. It demonstrates full-stack development and real-time booking logic."
            />
            <Card
              image={fsh1intermediate}
              title="Intermediate Project"
              description="A Swiggy clone project simulates a food delivery platform with restaurant listings, cart management, and real-time order tracking. It highlights full-stack development, API integration, and user-centric design."
            />
            <Card
              image={fsh1advanced}
              title="Advanced Project"
              description="A Meesho clone project replicates a social e-commerce platform with product listings, reseller features, and order management. It showcases skills in full-stack development, user authentication, and scalable UI design."
            />
          </section>
        </div>
      </>

      <div className="gr-ds-data-science">
      <h4>Why Full Stack Web Development Program?</h4>
      <h1>
        <span>Rising Demand</span> for Web Development and AI Skills and Career Growth
      </h1>
      {/* <div className="gr-ds-tabs">
        {["Front-End", "Back-End"].map((tab) => (
          <span
            key={tab}
            className={activeTabing === tab ? "gr-ds-selected-tab" : "gr-ds-inactive-tab"}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </span>
        ))}
      </div> */}
      <div className="gr-ds-container">
        <div className="gr-ds-graph">
          {showGraphs && <CanvasJSChart options={options} />}
        </div>
        <div className="gr-ds-companies">
          <h3>Top Companies Hiring</h3>
          <div className="gr-ds-company-list">
            {companyImages.map((image, index) => (
              <img key={index} src={image} alt={`company-${index}`} className="gr-ds-company-image" style={{ "--delay": index }} />
            ))}
          </div>
        </div>
        <div className="gr-ds-demand">
          
          <div className="gr-ds-demand-card">
          <h3>Demand</h3>
            <FaBriefcase className="gr-ds-icon" />
            <p>52% Growth in Developer Job Roles by 2028</p>
          </div>
        </div>
      </div>
    </div>

      {/* <div className="hirrecompanyfull"> */}

      <div className="hire-company-container">
        <div className='hire-company-part-a'>
          <div className='hire-company-sub-part'>
            <FaUsersLine className='hire-course-icon' />
            <p1 className='hire-course-icon-tag'>750 HIRING PARTNERS</p1>
          </div>
          <div className="hire-company-logos">
            {companyLogos.map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt={`Logo ${index + 1}`}
                className="hire-logo-course"
              />
            ))}
          </div>
        </div>
        <div className="trusted-section">
          <img className="trusted-img" src={trusted} alt="Trusted" />
        </div>
      </div>
      {/* </div> */}

      <div className='cp-mentors'>
        <div className='cp-mentor-title'>
          <p1>ALUMINI</p1>
          <p2>working at companies bigger brands and are extremely important to us and we are grateful for the opportunity to have placed them on such impressive teams around the country.</p2>
        </div>
        <div className='cp-mentor-components'>
          <div className="carousel-container">
            <div className="cp-mentor-components carousel-track">
              {/* Duplicating list for infinite scrolling effect */}
              {[...mentors, ...mentors].map((mentor, index) => (
                <div className="cp-mentor-1" key={index}>
                  <img src={mentor.image} alt={mentor.name} className="cp-mentor-image" />
                  <div className="cp-mentor-1-data">
                    <p1>{mentor.name}</p1>
                    <p2>{mentor.role}</p2>
                    <div className="cp-mentor-company-image-div">
                      <img src={mentor.company} alt="Company" className="cp-mentor-company-image" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="cr-certification-container">

      <h2>Industry Recognized Certification Course</h2>

<div className="cr-certification-content">

  <div className="cr-certification-text">
  <div className="cr-certification-tabs">
  {Object.keys(certifications).map((tab) => (
    <span
      key={tab}
      className={activeTab === tab ? 'active' : ''}
      onClick={() => setActiveTab(tab)}
    >
      {tab}
    </span>
  ))}
</div>
    <h3>{certifications[activeTab].title}</h3>
    <ul>
      {certifications[activeTab].points.map((point, index) => (
        <li key={index}>&#10004; {point}</li>
      ))}
    </ul>
  </div>
  <div className="cr-certification-image">
    <img src={certifications[activeTab].img} alt={activeTab} />
  </div>
</div>
</div>


      <div className="bootcamp-container">
        <header className="bootcamp-header">
          <h3 className="bootcamp-subheading">
            Tools We Use and Learn
          </h3>
        </header>

  <section className="bootcamp-offerings">
          <Cards
            image={fsreact}
            title="React JS"
            description="React.js is a JavaScript library developed by Facebook for building fast, interactive user interfaces, especially for single-page applications (SPAs). It uses a component-based architecture, enabling developers to break the UI into reusable pieces for easier maintenance and scalability."
          />
          <Cards
            image={fsnode}
            title="Node JS"
            description="Node.js is a JavaScript runtime built on Chrome's V8 engine, designed for building fast, scalable network applications. It uses an event-driven, non-blocking I/O model, making it ideal for real-time web applications. Node.js is particularly well-suited for real-time applications like chat, streaming due to its non-blocking, event-driven architecture."
          />
          <Cards
            image={fsexpress}
            title="Express JS"
            description="Express.js is a minimal and flexible Node.js web application framework that provides robust features for building APIs and web applications. It simplifies the process of routing, handling HTTP requests, middleware integration, and server-side logic. With Express.js, developers can rapidly build scalable, maintainable backend services using JavaScript."
          />
          <Cards
            image={fsmongodb}
            title="Mongo DB"
            description="MongoDB is a NoSQL, document-oriented database that stores data in flexible, JSON-like documents. It allows for scalable and high-performance data storage, ideal for modern web and mobile applications. With its schema-less structure, MongoDB makes it easy to iterate and evolve applications quickly."
          />
          <Cards
            image={fsfigma}
            title="Figma"
            description="Figma is a web-based interface design and prototyping tool used by UI/UX designers for real-time collaboration. It allows teams to design, share, and iterate on interactive user interfaces directly in the browser."
          />
          <Cards
            image={fspostman}
            title="Postman"
            description="Postman is a collaboration platform for API development that simplifies building, testing, and documenting APIs. It allows users to send requests, inspect responses, and automate test scripts in an easy-to-use interface. With features like collections, environments, monitors, and mock servers, Postman streamlines the entire API lifecycle."
          />
    
        </section>
      </div>

      <div className='cp-pricing-container'>
        <p className='cp-pricing-title'>Simple, Transparent Pricing</p>
        <div className='cp-pricing-box'>
          <div className='cp-price-left'>
            <h3>What's Included in the Price</h3>
            <p>Features/Benefits</p>
            <ul>
              <li>Get Advanced Certificate Programme from Hruthi AI Tech Hub without quitting your job.</li>
              <li>Practical Learning with Industry Projects and Case Studies</li>
              <li>Rigorous Cutting Edge Curriculum developed in Collaboration with Teaching experts and Industry leaders in Full Stack</li>
              <li>Dedicated Student support team from Hruthi AI Tech Hub</li>
              <li>Networking opportunities with our alumni & leading industry experts</li>
            </ul>
          </div>
          <div className='cp-price-right'>
            <h2>Empowering learners of tomorrow</h2>
            <p>Over 2,300 students have completed this course and started working at their dream job, whats stopping you?</p>
          </div>
        </div>
      </div>

      <div className='cp-booking-container'>
        <div className='cp-booking-session'>
          <h1>Book live demo class now!</h1>
          <h3>Register now for our FREE live demo class on full-stack web development.</h3>
          <button className='cp-booking-button'>Register Now</button>
        </div>
      </div>

      <div className="faq-container">
        <h3 className="faq-title">FAQ</h3>
        <h1 className="faq-heading">Frequently Asked Questions</h1>
        <div className="faq-content">
          {/* Left Tabs */}
          <div className="faq-tabs">
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`Course14-tab ${activeTabs === index ? "active" : ""}`}
                onClick={() => toggleTab(index)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Right FAQ Section */}
          <div className="faq-details">
            <h2 className="faq-question">{faqs[activeTabs].question}</h2>
            {faqs[activeTabs].answer && (
              <p className="faq-answer">{faqs[activeTabs].answer}</p>
            )}
            <ul className="faq-list">
              {faqs.map((faq, index) =>
                activeTabs !== index ? (
                  <li key={index} className="faq-list-item">
                    {faq.question} <span className="faq-toggle">+</span>
                  </li>
                ) : (
                  <li key={index} className="faq-list-item active">
                    {faq.question} <span className="faq-toggle">×</span>
                  </li>
                )
              )}
            </ul>
            <button className="view-more-btn">View More</button>
          </div>
        </div>
      </div>

    </div>
  )
}

export default FullStack
